/**
 * 彩种
 **/
import request from '@/utils/request'

/**
 * 获取所有彩种
 * @param {彩种ident}} loty 
 * @returns 
 */
export function getList() {
    return request.post('/index/lottory/get_list',{
    
    });
}


/**
 * 新加了通过彩种获取玩法的接口
 * @param {*} loty 
 * @returns 
 */
export function getWanfaList(loty) {
    return request.post('/index/lottory/get_wanfa_list',{
        loty: loty,
    });
}

 
/**
 * 获取开奖倒计时
 * @param {*} loty 
 * @returns 
 */
export function getCountIndex(loty) {
    return request.post('/index/Count/index',{
        loty: loty,
    });
}

/**
 * 获取开奖记录
 * @param {*} loty 
 * @returns 
 */
 export function getHistory(loty) {
    return request.post('/index/history',{
        loty: loty,
    });
}


// WEBPACK FOOTER //
// ./src/api/lottery.js